import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "scenario-grid__copy" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }

import { computed } from 'vue'

export interface ScenarioGridItem {
  key: string
  title: string
  image: string
  alt?: string
  imageAlt?: string
  description?: string
  descriptionHtml?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScenarioGrid',
  props: {
    items: {},
    ariaLabel: { default: '' },
    desktopColumns: { default: 3 },
    tabletColumns: { default: 2 },
    mobileColumns: { default: 1 },
    gap: { default: '24px' },
    cardRadius: { default: 'var(--pixso-radius-lg)' },
    cardAspectRatio: { default: '584 / 382' },
    titleFontSize: { default: 'var(--pixso-fs-36)' },
    titleLineHeight: { default: 'var(--pixso-lh-36)' },
    descriptionFontSize: { default: '16px' },
    descriptionLineHeight: { default: '24px' },
    descriptionFontWeight: { default: '400' },
    descriptionFontFamily: { default: 'HarmonyOS Sans' },
    copyInsetX: { default: '24px' },
    copyInsetBottom: { default: '24px' }
  },
  setup(__props: any) {

const props = __props

const gridStyle = computed(() => ({
  '--scenario-grid-columns-desktop': String(props.desktopColumns),
  '--scenario-grid-columns-tablet': String(props.tabletColumns),
  '--scenario-grid-columns-mobile': String(props.mobileColumns),
  '--scenario-grid-gap': props.gap,
  '--scenario-grid-card-radius': props.cardRadius,
  '--scenario-grid-card-aspect-ratio': props.cardAspectRatio,
  '--scenario-grid-title-font-size': props.titleFontSize,
  '--scenario-grid-title-line-height': props.titleLineHeight,
  '--scenario-grid-description-font-size': props.descriptionFontSize,
  '--scenario-grid-description-line-height': props.descriptionLineHeight,
  '--scenario-grid-description-font-weight': props.descriptionFontWeight,
  '--scenario-grid-description-font-family': props.descriptionFontFamily,
  '--scenario-grid-copy-inset-x': props.copyInsetX,
  '--scenario-grid-copy-inset-bottom': props.copyInsetBottom
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "scenario-grid",
    "aria-label": _ctx.ariaLabel,
    style: _normalizeStyle(gridStyle.value)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("article", {
        key: item.key,
        class: "scenario-grid__card"
      }, [
        _createElementVNode("img", {
          class: "scenario-grid__media",
          src: item.image,
          alt: item.alt || item.imageAlt || item.title,
          loading: "lazy"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
          (item.descriptionHtml)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                "data-text-reveal": "off",
                innerHTML: item.descriptionHtml
              }, null, 8, _hoisted_4))
            : (item.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.description), 1))
              : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ], 12, _hoisted_1))
}
}

})